<template>
  <v-radio-group
      class="configurationModeSelection"
      :value="value"
      @change="onSelect"
      :column="false">
    <v-radio value="AUTO">
      <template slot="label">
        <div class="configOption">
          <h3 class="title">{{ $t("CONFIGURATOR_MODE_AUTO") }}</h3>
          <p>{{ autoChoiceSettingLabel }}</p>
        </div>
      </template>
    </v-radio>
    <v-radio value="DETAILED">
      <template slot="label">
        <div class="configOption">
          <h3 class="title">{{ $t("CONFIGURATOR_MODE_DETAILED") }}</h3>
          <p>{{ detailedChoiceSettingLabel }}</p>
        </div>
      </template>
    </v-radio>
  </v-radio-group>
</template>

<script lang="ts">
import Component from 'vue-class-component'
import BasicComponent from "@/global/BasicComponent";
import {Prop} from "vue-property-decorator";
import {ProductDto} from "@swagger";

@Component({
  components: {}
})
export default class ConfigurationModeSelector extends BasicComponent {

  @Prop(String) value: string;
  @Prop(Object) product: ProductDto;

  mounted() {
  }

  onSelect(event): void {
    this.$emit("input", event);
    this.$emit("select");
  }

  get autoChoiceSettingLabel(): string {
    const types = [...new Set(this.flattenArray(this.product.imageRequirements.map(r => r.types)))];
    const names = types.map(t => this.$t("IMAGE_NAME_" + t));
    const concat = this.replaceLast(names.join(", "), ",", " &");
    if (types.length > 1) {
      return this.$t("CONFIGURATOR_MODE_AUTO_MULTIPLE_DESCRIPTION").toString().replace("{images}", concat);
    } else {
      return this.$t("CONFIGURATOR_MODE_AUTO_SINGLE_DESCRIPTION").toString().replace("{image}", concat);
    }
  }

  get detailedChoiceSettingLabel(): string {
    let label = this.$t('CONFIGURATOR_MODE_DETAILED_DESCRIPTION').toString();
    if (this.product.detailedConfigurationSurcharge > 0) {
      label += ` (+ ${this.formatPrice(this.product.detailedConfigurationSurcharge)})`;
    }
    return label;
  }

}

</script>
<style lang="scss" scoped>

</style>
<style lang="scss">
@use "../../stylesheets/Configurators.scss";
.configurationModeSelection {
  max-width: calc(100% - 32px);
  margin: 0 auto;

  @media screen and (max-width: 500px) {
    max-width: 100%;
  }

  div[role="radiogroup"] {
    justify-content: center;
    flex-wrap: wrap;

    .v-radio {
      padding: 15px;
      padding-bottom: 0;
      margin-left: 8px;
      margin-right: 8px;
      max-width: 320px;

      .v-label {
        height: 100%;
        width: 100%;

        .configOption {
          height: 100%;
          width: 100%;
        }
      }

      @media screen and (max-width: 650px) {
        display: block;
        max-width: 100%;
        width: 100%;
        padding: 5px;
      }
    }

    .configOption {
      padding: 10px 5px 5px 5px;
    }

    .v-input--selection-controls__input {
      display: none !important;
    }
  }
}
</style>